import CustomChartLegend from 'components/chart/chart-legend/custom-chart-legend';
import UngroupedChartToolTip from 'components/chart/chart-tooltip/ungrouped-chart-tooltip';
import DynamicDonutChart from 'components/chart/donut-chart/dynamic-donut-chart';
import { formatPercentage } from 'components/fomatter/percentage/percentage-formatter';
import { colorArray } from 'components/chart/line-chart/components/chart-components-style';
import { FundPortfolio, Portfolio } from 'model/fund';
import React from 'react';

interface WalletDiskGraphProps {
    portfolio: Portfolio | undefined;
}

const formatSharePercentage = (value: number): string => formatPercentage(value / 100);

const customizeDonutToolTip = (id: string, value: number, color: unknown) => {
    return `
    <div style="display: flex; align-items: center">
        <div style="background-color:${color}; width: 10px; height: 10px; display: inline-block; margin-right: 5px"></div>
        <b style="font-size: 10px">${id}</b>
    </div>
    <hr style="margin: 5px 0" />
    <b>${formatSharePercentage(value)}</b>`;
};

const WalletDiskGraph = (props: WalletDiskGraphProps) => {
    const { portfolio } = props;

    const sortedPortfolio: FundPortfolio[] | undefined = portfolio?.funds.sort((a, b) => b.sharePercentage - a.sharePercentage);

    return (
        <div className="infos-container--child">
            <UngroupedChartToolTip customize={customizeDonutToolTip}>
                {tooltip => (
                    <DynamicDonutChart
                        data={sortedPortfolio?.map(it => [it.name, it.sharePercentage])} // mocking only one value of array (optional)
                        config={{
                            height: 225,
                            width: 225,
                            categoriesKeys: ['name', 'sharePercentage'],
                            labelFormat: formatSharePercentage,
                            donutWidth: 55,
                            colorPatern: colorArray,
                            donutLabelPositionAdjust: 0.9
                        }}
                        tooltipOptions={tooltip}
                    >
                        {(chart, keys) => (
                            <CustomChartLegend
                                chart={chart}
                                keys={[]}
                                formatKey={key => (key === 'totalValue' ? 'totalValue' : key)} // map key to desired label
                            />
                        )}
                    </DynamicDonutChart>
                )}
            </UngroupedChartToolTip>
        </div>
    );
};

export default WalletDiskGraph;
